<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>
<script>
import {
  getList,
	update
} from "@/api/order/intercept";
import {
	removeBlocks,
} from "@/api/order/list";
import cTable from "@/base/common/index";
import { getSelectType } from "@/api/public";
// import { getAllClient, getCompanies } from "@/api/user/client";
// import { getCurrency } from "@/api/finance/currency";
// import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
// import { getChargingType } from "@/api/double/list";
// import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
export default {
  name: "intercept",
	components:{
		cTable
	},
  async created() {
		
		this.status = (await getSelectType('INTERCEPT_STATUS')).data.payload['INTERCEPT_STATUS']
		this.statusObj = this.status.reduce((a,b)=>{
			a[b.value] = b.label
			return a
		},{})
		// let agentList = (await getAgent()).data.payload.rows
		
		this.header.searchs.forEach(async item=>{
			if(item.key === 'status')item.options = this.status
			if (item.key === "client_id")
			  item.options = (await getAllClient()).data.payload.rows;
			if (item.key === "customer_service_id")
				item.options = (
					await getUser({ standard: "CustomerService" })
				).data.payload.rows;
		})
		// this.modals.add.fields.forEach(t=>{
		// 	if(t.key === 'cod_agent')t.options = agentList
		// })
  },
  methods: {},
  data() {
    let that = this;
    return {
			status:[],
			statusObj:[],
			agentList:[],
			configs:{},
			client:[],
			companies:[],
			unit:[],
			bubble:[],
			currencyList:[],
			SubjectCost:[],
      methods: {
				getSelectType,
        list(params){
					return getList(params)
				},
				update,
				removeBlocks
      },
      modals: {
        add: {
					type:'add',
          methods: {
            ok({ row, close }) {
							let data = JSON.parse(JSON.stringify(row))
							data.airway_number = data.airway_number.split('\n')
              this.$page.handleRequestMethods('update', data, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
							status: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number'
							  },
							],
							airway_number: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
            },
          },
          grid: [
            {status:24},
            {airway_number:24},
            {remarks:24},
          ],
          fields: [
						{
						  name: this.$t("order_number"),
						  key: "airway_number",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("order_number"),
						  bind: {
						    type: "textarea",
						    rows: 8
						  }
						},
						{
						  name: this.$t("Remarks"),
						  key: "remarks",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("Remarks"),
						  bind: {
						    type: "textarea",
						    rows: 3
						  }
						},
            {
              key: "status",
              name: () => this.$t("tip"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("tip")
                );
              },
              options: [],
							methods:{
								list:({field})=>{
									field.options = this.status
								}
							}
            },
          ],
        },
      },
      header: {
        searchs: [
					
					 {
						 key: "status",
						 component: "Select",
						 placeholder() {
							 return this.$t("tip");
						 },
						 clearable: true,
						 options: [],
						 bind: {
							 style: "width:140px"
						 },
					},
					{
						key: "client_id",
						component: "Select",
						placeholder() {
							return this.$t("select") + this.$t("clientName");
						},
						clearable: true,
						options: [],
						config: { label: "account", value: "id" },
						bind: {
							style: "width:150px",
						},
					},
					{
						key: "customer_service_id",
						component: "Select",
						bind: {
							style: "width:150px",
						},
						placeholder() {
							return this.$t("select") + this.$t("serviceAccount");
						},
						options: [],
						config: { label: "account", value: "id" },
					},
          {
            key: "keywords",
            placeholder() {
              return this.$t("order_number");
            },
            bind: {
              type: "textarea",
              rows: 2,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("Update Status"),
              fnName: "updateStatus",
              type: "updateStatus",
              bind: {
                type: "primary",
              },
            },
						{
							name: () => this.$tz("解除拦截"),
							type: "int",
							fnName: "int",
							bind: {
								type: "primary",
								// icon: "md-swap",
							},
							disabled() {
								return !this.selectAll.length;
							},
							id: 1708
						},
          ],
          methods: {
						int() {
							this.$Modal.confirm({
								title: this.$tz('是否,解除拦截'),
								width: 300,
								content: this.$t('titleModal'),
								onOk: () => {
									this.handleRequestMethods('removeBlocks', { airway_number: this.selectAll.map((item) => item.airway_number) }, true, true).then(
										res => {
											this.getList()
										}
									);
								}
							})
						},
          	updateStatus(){
          		this.getModal('add').open({airway_number:this.selectAll.map(t=>t.airway_number).join('\n')},function(){
          			this.setTitle(this.$t("Update Status"));
          		})
          	},
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
				{
				  name: this.$t("order_number"),
				  key: "airway_number",
				  minWidth: 120,
					header:{
						copy:true
					}
				},
				{
				  name: this.$t("allow_depart"),
				  key: "from_country",
				  minWidth: 120,
				},
				{
				  name: this.$t("allow_arrive"),
				  key: "to_country",
				  minWidth: 120,
				},
				{
				  name: this.$t("localFaction"),
				  key: "deliver",
				  minWidth: 120,
				},
				{
				  name: this.$t("order_refCode"),
				  key: "agent_refer_code",
				  minWidth: 120,
				},
				{
				  name: this.$t("tip"),
				  key: "status",
				  minWidth: 120,
					methods:{
						render:({value})=>{
							return this.statusObj[value]
						}
					}
				},
				{
				  name: this.$t("Update Status Time"),
				  key: "update_status_time",
				  minWidth: 120,
				},
				{
				  name: this.$t("b2bClient"),
				  key: "client_name",
				  minWidth: 120,
				},
				{
				  name: this.$t("salesman"),
				  key: "salesman_name",
				  minWidth: 120,
				},
				{
				  name: this.$t("operate"),
				  key: "operator_name",
				  minWidth: 120,
				},
				
				{
				  name: this.$t("order_type_t"),
				  key: "type",
				  minWidth: 120,
				},
				{
				  name: this.$t("tracker_code"),
				  key: "tracker_status",
				  minWidth: 120,
				},
				{
				  name: this.$t("track_title"),
				  key: "status_remarks",
				  minWidth: 120,
				},
				{
				  name: this.$t("tracker_time"),
				  key: "status_time",
				  minWidth: 120,
					methods:{
						render({value}){
							return value?this.format.zoneTime(value*1000):''
						}
					}
				},
				
       /* {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
							// id:1258
            },
          ],
          methods: {
          },
        }, */
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
